import { createLogger } from '@west-tennessee-consulting/logger';

export const logger = createLogger({ service: 'hub' });
export type { Logger } from '@west-tennessee-consulting/logger';
